import {
  STATISTICS_VIEWERS_TABLE_STORE, StatisticsViewersTableStore, StatsTableEntity
} from 'store'
import { StyleProps } from 'utilities'

export type ViewersProjectTableBodyLineProps = StyleProps & {
    tableEntity: StatsTableEntity
    mainEntitySubLevel?: number
    [STATISTICS_VIEWERS_TABLE_STORE]?: StatisticsViewersTableStore
}

export enum SelectedEntityGraphColor {
    FIRST = '#254291',
    SECOND = '#3AABF2',
    THIRD = '#70D6C6',
    FORTH = '#70D6C6',
    FIFTH = '#70D6C6',
    SIXTH = '#70D6C6'
}
